var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "py-8 bg-white rounded-lg bx-shadow mt-3"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 1,
      expression: "step === 1"
    }],
    staticClass: "flex justify-center flex-col items-center register",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('h2', {
    staticClass: "text-black text-center font-medium text-2xl register-title"
  }, [_vm._v("Create Account")]), _c('v-form', {
    ref: "registerForm",
    staticClass: "register-form",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      }
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "section-label"
  }, [_vm._v("Personal Info")])]), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "outlined": "",
      "clearable": "",
      "dense": "",
      "label": "First Name",
      "prepend-inner-icon": "mdi-account-outline",
      "hide-details": "",
      "color": "orange darken-1"
    },
    model: {
      value: _vm.form.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "firstName", $$v);
      },
      expression: "form.firstName"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "clearable": "",
      "dense": "",
      "label": "Last Name",
      "prepend-inner-icon": "mdi-account-outline",
      "hide-details": "",
      "color": "orange darken-1"
    },
    model: {
      value: _vm.form.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "lastName", $$v);
      },
      expression: "form.lastName"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "outlined": "",
      "clearable": "",
      "dense": "",
      "label": "Email",
      "prepend-inner-icon": "mdi-email-outline",
      "hide-details": "",
      "color": "orange darken-1"
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('VuePhoneNumberInput', {
    staticStyle: {
      "height": "48px !important"
    },
    attrs: {
      "default-country-code": _vm.selectedCountryCode,
      "error": !_vm.phoneValid,
      "clearable": true,
      "countries-height": 46
    },
    on: {
      "update": _vm.logPhone
    },
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-1 pt-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "section-label"
  }, [_vm._v("Password")])]), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "12",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "40px",
      "width": "100%"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.uuidv4
    }
  }, [_vm._v("Generate Password")])], 1), _c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "append-icon": _vm.passEye ? 'mdi-eye-outline' : 'mdi-eye-off-outline',
      "outlined": "",
      "clearable": "",
      "dense": "",
      "label": "Password",
      "prepend-inner-icon": "mdi-lock-outline",
      "type": _vm.passEye ? 'text' : 'password',
      "hide-details": "",
      "color": "orange darken-1"
    },
    on: {
      "click:append": function ($event) {
        _vm.passEye = !_vm.passEye;
      }
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }), _c('password-control', {
    attrs: {
      "ifCondition": this.form.password && this.form.password !== '',
      "password": this.form.password,
      "passwordConfirm": _vm.passwordConfirm
    },
    on: {
      "done": function ($event) {
        _vm.isDone = $event;
      }
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "4",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "append-icon": _vm.passEye ? 'mdi-eye-outline' : 'mdi-eye-off-outline',
      "hide-details": "",
      "dense": "",
      "type": _vm.passEye ? 'text' : 'password',
      "outlined": "",
      "clearable": "",
      "label": "Password Confirm",
      "prepend-inner-icon": "mdi-lock-check-outline",
      "color": "orange darken-1"
    },
    on: {
      "click:append": function ($event) {
        _vm.passEye = !_vm.passEye;
      }
    },
    model: {
      value: _vm.passwordConfirm,
      callback: function ($$v) {
        _vm.passwordConfirm = $$v;
      },
      expression: "passwordConfirm"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-1 pt-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "section-label"
  }, [_vm._v("Tenant & Language")])]), _c('v-col', {
    staticClass: "register-tenant pb-0",
    attrs: {
      "cols": "12",
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('SelectTenant', {
    attrs: {
      "isAll": true,
      "tenants": _vm.allTenants,
      "allTenants": _vm.listedTenants
    },
    on: {
      "onSelect": function ($event) {
        return _vm.selectTenant($event);
      }
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "label": "Select Language",
      "prepend-inner-icon": "mdi-translate",
      "outlined": "",
      "hide-details": "",
      "clearable": "",
      "color": "orange darken-1"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "color": "grey darken-3"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on;
              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-help-circle-outline")])];
            }
          }])
        }, [_c('span', [_vm._v("The email will be sent in the selected language.")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedLanguage,
      callback: function ($$v) {
        _vm.selectedLanguage = $$v;
      },
      expression: "selectedLanguage"
    }
  })], 1), _c('v-col', {
    staticClass: "pb-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    staticStyle: {
      "font-size": "13px",
      "margin-bottom": "0",
      "margin-top": "-8px",
      "border-radius": "8px"
    },
    attrs: {
      "type": "info",
      "color": "accent",
      "dense": "",
      "text": ""
    }
  }, [_vm._v(" An email with password information will be sent to the account's email address. ")])], 1), _c('v-col', {
    staticClass: "pt-4 d-flex justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "44px",
      "width": "280px",
      "font-size": "14px",
      "border-radius": "8px",
      "letter-spacing": "0.8px"
    },
    attrs: {
      "dark": "",
      "color": "accent",
      "elevation": "1"
    },
    on: {
      "click": _vm.register
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }]
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-account-plus-outline")]), _vm._v(" Create Account ")], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "mng-loader"
  })])], 1)], 1)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }